module.exports = __webpack_public_path__ + "a80d231c.png";